<script>
import Layout from '@layouts/main';
import DownloadCategoryForm from '@views/download-categories/form';

export default {
  components: {
    Layout,
    DownloadCategoryForm,
  },
  page() {
    return {
      title: this.$t('titles.create_download_category'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.download_categories'),
          to: { name: 'downloadCategories.index' },
        },
        {
          text: this.$t('titles.create_download_category'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({ name: 'downloadCategories.index' });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_download_category')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <DownloadCategoryForm @submitted="create" />
    </b-card>
  </Layout>
</template>
